import SnappyCompressor from "./SnappyCompressor";

function isUint8Array(target) {
  return target instanceof Uint8Array;
}

function isArrayBuffer(target) {
  return target instanceof ArrayBuffer;
}

function isBuffer(target) {
  return Buffer.isBuffer(target);
}

function stringToArrayBuffer(content) {
  var u8a = new Uint8Array(content.length);

  for (var i = 0; i < content.length; i++) {
    u8a[i] = content.charCodeAt(i);
  }

  return u8a.buffer;
}

function compress(uncompressed) {
  if (!isUint8Array(uncompressed) && !isArrayBuffer(uncompressed) && !isBuffer(uncompressed)) {
    throw new TypeError('Argument compressed must be type of ArrayBuffer, Buffer, or Uint8Array');
  }

  var uint8Mode = false;
  var arrayBufferMode = false;
  var sources;

  if (isUint8Array(uncompressed)) {
    uint8Mode = true;
    sources = uncompressed;
  } else if (isArrayBuffer(uncompressed)) {
    arrayBufferMode = true;
    sources = new Uint8Array(uncompressed);
  }

  var compressor = new SnappyCompressor(sources);
  var maxLength = compressor.maxCompressedLength();
  var compressed;
  var compressedView;
  var length;

  if (uint8Mode) {
    compressed = new Uint8Array(maxLength);
    length = compressor.compressToBuffer(compressed);
  } else if (arrayBufferMode) {
    compressed = new ArrayBuffer(maxLength);
    compressedView = new Uint8Array(compressed);
    length = compressor.compressToBuffer(compressedView);
  } else {
    compressed = Buffer.alloc(maxLength);
    length = compressor.compressToBuffer(compressed);
  }

  return compressed.slice(0, length);
}

export default function SnappyCompress(content) {
  var arrayBuffer = stringToArrayBuffer(content);
  return compress(arrayBuffer);
}